<template>
  <div id="detailed">
    <header>
      <el-button type="primary" icon="el-icon-arrow-left" style="float: left" circle @click="goBack"></el-button>
      <div style="color: #ffffff">{{titleName}}</div>
      <div class="header-device">
        <div>
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="el-dropdown-link">
<!--              <p style="margin-top: -1%;color: #ffffff">设备名称：</p>-->
              {{selectDeviceName}} <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
            </div>
            <el-dropdown-menu style="max-height: 50vw;max-width: 60vw; overflow: auto" slot="dropdown">
              <el-dropdown-item v-for="(item, index) in deviceList" :key="index" :command="item">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </header>
    <main :class="findKey == false ? 'form-onlyRead':''">
      <mobile-real  ref="mobileReal" v-show="realFlg"/>
      <mobile-statistics ref="mobileStatistics" v-show="statisticsFlg"/>
    </main>
    <footer>
      <div :class="index == 1 ? 'bottom_icon_1' : 'bottom_icon'" @click="realChange(1)">
        <img :src="index == 1 ? require('./img/real1.png') : require('./img/real.png')"/>
        <p style="margin-top: -5%">{{$t("mobileRealTime")}}</p>
      </div>
      <div :class="index == 2 ? 'bottom_icon_2': 'bottom_icon'" @click="statisticsChange(2)">
        <img :src="index == 2 ? require('./img/statistics1.png') : require('./img/statistics.png')"/>
        <p style="margin-top: -5%">{{$t("mobileStatisticalRain")}}</p>
      </div>
    </footer>
  </div>
</template>

<script>
  import router from "../router"
  import mobileReal from "./MobileReal"
  import mobileStatistics from "./MobileStatistics"
  import {
    getAdminDevice,
    getCustomerDevice,
    getCredentials,
    getDeviceKey
  } from "../untils/api/home"
  export default {
    name: 'mobileDetailed',
    components: {mobileReal, mobileStatistics},
    data() {
      return {
        titleName: this.$t("mobileReal"),
        index: 1,
        selectDeviceName: '',
        selectDeviceId: '',
        deviceList: [],
        realFlg: true,
        statisticsFlg: false,
        deviceInfo: {},
        credentialsId: '',
        findKey: true,
        key: 'rainfall',
        // key: 'rainfallf',
        // key: 'rainfallg',
        // key: 'rainfally1',
      }
    },

    mounted() {
      //用户等级
      let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      //获取用户设备列表
      if(authority === 'TENANT_ADMIN') {//管理员
        getAdminDevice().then(response => {
          this.setDeviceList(response);
        }).catch(error => {
          console.log("error",error)
        })
      } else { //普通用户
        getCustomerDevice(customerId).then(response => {
          this.setDeviceList(response);
        }).catch(error => {
          console.log("error",error)
        })
      }
    },

    beforeDestroy() {
      let local = localStorage.getItem('locale');
      localStorage.clear();
      localStorage.setItem('locale',local)
    },

    methods: {
      /**
       * 初期化获取用户下所有设备
       * @param response
       */
      setDeviceList(response) {
        if(response.data.length === 0) return;
        for(let i = 0; i < response.data.length; i++){
          let deviceJson = {};
          deviceJson.id = response.data[i].id.id;
          deviceJson.name = response.data[i].name;
          this.deviceList.push(deviceJson);
        }
        //默认选中设备
        this.selectDeviceId = this.deviceList[0].id;
        this.selectDeviceName = this.deviceList[0].name;
        this.getDeviceInfo();
      },

      /**
       * 选择设备获取对应的用户名已经用户id
       * @param command
       */
      handleCommand(command) {
        this.selectDeviceId = command.id;
        this.selectDeviceName = command.name;
        this.getDeviceInfo();
      },

      /**
       * 获取设备信息
       */
      getDeviceInfo() {
        getCredentials(this.selectDeviceId).then(response => {
          this.deviceInfo = response.deviceId;
          this.credentialsId = response.credentialsId;
          this.$refs.mobileReal.initMobileReal(this.deviceInfo, this.credentialsId, this.key);//初期化实时画面数据
          this.$refs.mobileStatistics.initMobileStatistics(this.deviceInfo, this.key);
          this.getDeviceKeys();
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 获取所有要素名称
       */
      getDeviceKeys() {
        getDeviceKey(this.deviceInfo.entityType, this.deviceInfo.id).then(response => {
          if(response.indexOf(this.key) > -1){//判断要素内是否包含雨量
            this.findKey = true;
            this.$refs.mobileReal.minuteInfo();//获取一小时内雨量
            this.$refs.mobileReal.hourInfo();//获取前一小时雨量
            this.$refs.mobileReal.getRainHour();//获取日分界时
          } else {
            this.findKey = false;
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t("mobileDeviceError")
            });
          }
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 切换到实时雨量画面
       * @param i
       */
      realChange(i) {
        this.realFlg = true;
        this.statisticsFlg = false;
        this.titleName = this.$t("mobileReal");
        this.index = i;
      },

      /**
       * 切换到统计雨量
       * @param i
       */
      statisticsChange(i) {
        this.realFlg = false;
        this.statisticsFlg = true;
        this.titleName = this.$t("mobileStatistical");
        this.index = i;
      },

      /**
       * 退出
       */
      goBack() {
        let local = localStorage.getItem('locale');
        localStorage.clear();
        localStorage.setItem('locale',local);
        router.replace('/')
      }
    }
  }
</script>

<style lang="less" scoped>
  @media screen and (max-width: 500px){
    #detailed {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      //background-color: #34455f;//#1c2735   #34455f
      background-image: url("./img/login.png");
      /*background-image: url("./img/login2.gif");*/
      background-size: cover;
    }
    header {
      width:100%;
      height: 15vw;
      font-size: 5vw;
      position:absolute;
      z-index:5;
      top:0;
      text-align:center;
      color: #ffffff;
      padding-top: 1vw;

      .header-device {
        margin-bottom: 3%;
        height: 5%;
        width: 100%;
        color: #ffffff;
        text-align: center;
        font-size: 4vw;
        margin-top: 1%;
      }

      .el-button--primary {
        //background-color: #34455f; //#39383f  #0089cc  121423
        background-color: rgba(52, 69, 95, 0.1);
        font-size: 8vw;
        border: none;
        color: #ffffff;
        margin-top: 1%;
      }

      [class*=" el-icon-"], [class^=el-icon-] {
        line-height: 2;
      }
    }

    main {
      //background:#1c2735;//#334765 #0089cc #0d0c0f #39383f
      width:100%;
      overflow:auto;
      top:15vw;
      position:absolute;
      z-index:10;
      bottom:12vw;
      color: #ffffff;
    }

    footer {
      height: 12vw;
      width: 60%;
      position: absolute;
      z-index: 200;
      bottom: 0;
      text-align: center;
      display: flex;
      justify-content: space-between;
      margin-left: 20%;

      .bottom_icon {
        width: 20%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #dbdbdb;
      }

      .bottom_icon_1 {
        width: 20%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #83e2fd;
      }

      .bottom_icon_2 {
        width: 20%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #83e2fd;
      }
    }

    .form-onlyRead {
      pointer-events: none;
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #83e2fd; //#1890ff  #15FEDA #3e57ae
      font-size: 5vw;
      display: flex;
      justify-content: space-between;
      margin-top: -3%;
    }

    .el-icon-arrow-down {
      font-size: 3.5vw;
    }

    .el-dropdown-menu__item {
      line-height: 150px;
      font-size: 4vw;
    }

    .el-icon--right {
      margin-top: 23px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileDetailed.vue